import type { ReactNode } from 'react';

import { AppShell } from '@/shared/ui/templates/AppShell';

type Props = { rail?: ReactNode; sidebar: ReactNode; topbar: ReactNode; content: ReactNode; sidebarOpen?: boolean; onSidebarClose?: () => void };

/** The platform console shares the shell geometry; only its slots differ. */
export function PlatformShell(props: Props) {
  return <AppShell {...props} />;
}
